import { PROMO_ICON } from '../../constants/promoIcon';
import { IPromo } from '../../types/newbuilding/promos';

export const getPromoIcon = (promo?: IPromo, isTopPromo = false) => {
  if (promo == null) {
    return null;
  }

  const { authorLogoUrl, isBlackFriday, isFromBank, bank, promoType } = promo;

  if (isTopPromo && isBlackFriday && authorLogoUrl) {
    return authorLogoUrl;
  }

  return isFromBank && bank ? bank.secondSquareImageUrl || bank.logoUrl : PROMO_ICON.get(promoType);
};
